import { BrandIcon } from "./BrandIcon";
import { isIconUrl, resolveBrandIconId } from "../lib/cmsIconCatalog";
import { parseLibraryIcon } from "../lib/libraryIcons";

/**
 * Resuelve: URL | marca AGDYSA | lucide:* | ri:*
 */
export function ResolveCmsIcon({ icon, size = 36, className = "text-brand-icon", alt = "" }) {
  if (!icon) return null;

  if (isIconUrl(icon)) {
    return (
      <img
        src={icon}
        alt={alt || ""}
        width={size}
        height={size}
        className={`object-contain ${className}`}
        style={{ width: size, height: size }}
        loading="lazy"
      />
    );
  }

  const lib = parseLibraryIcon(icon);
  if (lib?.Component) {
    const Comp = lib.Component;
    return <Comp size={size} className={className} aria-hidden={alt ? undefined : true} />;
  }

  const brandId = resolveBrandIconId(icon);
  if (!brandId) return null;
  return <BrandIcon id={brandId} size={size} className={className} />;
}
